export default "__VITE_ASSET__BOYFKkyK__"